import { MutationTree } from 'vuex'
import { SearchState } from '@/store/modules/search/state'
import { Types } from '@/store/modules/search/types'
import isLocalStorageAvailable from '@/utils/isLocalStorageAvailable'

const LOCALSTORAGE_CONDITION_KEY = 'search_conditions' as const

export const mutations: MutationTree<SearchState> = {
  [Types.UPDATE_SEARCH_CONDITIONS]: (state, action) => {
    state.conditions = {
      ...state.conditions,
      ...action.payload,
    }
  },
  [Types.INITIALIZE_FETCH_MASTER_DATA]: (state) => {
    state.isMasterFetching = true
  },
  [Types.CACHE_SEARCH_MASTER_DATA]: (state, action) => {
    state.activities = action.payload.activities
    state.areasByPref = action.payload.areas
    state.isMasterFetching = false
    state.isMasterFetched = true
  },
  [Types.LOAD_CONDITIONS]: (state) => {
    // localStorageが利用できない場合は何もしない
    if (!isLocalStorageAvailable()) return

    try {
      const conditions = JSON.parse(
        localStorage.getItem(LOCALSTORAGE_CONDITION_KEY) || ''
      )
      state.conditions = { ...state.conditions, ...conditions }
    } catch (e) {
      return
    }
  },
  [Types.SAVE_CONDITIONS]: (state) => {
    // localStorageが利用できない場合は何もしない
    if (!isLocalStorageAvailable()) return

    localStorage.setItem(
      LOCALSTORAGE_CONDITION_KEY,
      JSON.stringify({
        // 現時点では `showFulLReservations` のみ保存する。
        // 他の条件も保存したい場合はここに追記するだけでOK
        showFullReservations: state.conditions.showFullReservations,
      })
    )
  },
}
